import { Paper, styled } from '@mui/material';

/** Shared page-header geometry: content left, actions centered on the banner. */
export const PageBanner = styled(Paper)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  boxSizing: 'border-box',
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  minHeight: 88,
  padding: theme.spacing(1, 0, 2),
  marginBottom: theme.spacing(3),
  '&&': {
    background: 'transparent',
    border: 0,
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: 0,
    boxShadow: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    minHeight: 96,
    padding: theme.spacing(1, 0, 2.5),
    gap: theme.spacing(3),
  },
}));
